import { render, staticRenderFns } from "./ScheduleEditWorkspace.vue?vue&type=template&id=2f4ad4a4"
import script from "./ScheduleEditWorkspace.vue?vue&type=script&lang=js"
export * from "./ScheduleEditWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports